/* eslint-disable no-console */

import {register} from 'register-service-worker'

//TODO mudar console.log para Vue.$log.debug
if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
        ready() {
            console.log(
                'App is being served from cache by a service worker.\n' +
                'For more details, visit https://goo.gl/AFskqB'
            )
        },
        registered() {
            console.log('Service worker has been registered.')
        },
        cached() {
            console.log('Content has been cached for offline use.')
        },
        updatefound() {
            console.log('New content is downloading.')
        },
        updated(registration) {
            console.log("New content is available; please refresh.");
            let worker = registration.waiting;
            worker.postMessage({action: 'skipWaiting'});
        },
        offline() {
            console.log('No internet connection found. App is running in offline mode.')
        },
        error(error) {
            console.error('Error during service worker registration:', error)
        },
        waiting(a, b) {
            console.log('waiting', a, b);
        }
    });
    //
    // let refreshing;
    // navigator.serviceWorker.addEventListener("controllerchange", function () {
    //     console.log("controllerchange");
    //     if (refreshing) return;
    //     //window.location.reload();
    //     refreshing = true;
    //
    // });
    //
    // navigator.serviceWorker.addEventListener("controlling", function () {
    //     console.log("controlling");
    //     if (refreshing) return;
    //     //window.location.reload();
    //     refreshing = true;
    //
    // });
}
